import React from 'react';
import type { CustomItemsInsightsReport } from 'model/CustomItemsInsightsReport';
import NetSalesCustomItemsBarChart from './charts/NetSalesCustomItemsBarChart';

interface Props {
    loading: boolean;
    report: CustomItemsInsightsReport;
}

export const CustomItemsInsightsCharts: React.FC<Props> = ({ loading, report }) => {
    return (
        <NetSalesCustomItemsBarChart
            loading={loading}
            report={report}
        />
    );
};

export default CustomItemsInsightsCharts;
